<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="班级:">
              <treeselect
                v-model="table.where.classId"
                :options="classTree"
                :disable-branch-nodes="true"
                placeholder="请选择所属班级"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addClassEquiment" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加设备绑定</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="uuid" label="设备编码" show-overflow-tooltip />
          <el-table-column label="班级" show-overflow-tooltip>
            <template #default="{row}">
              {{ row.branchName + '-' + row.gradeName + '-' + row.className }}
            </template>
          </el-table-column>
          <el-table-column label="设备类型" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.type == 1 ? '蓝牙' : '扫码' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <!--              <el-link @click="editClassTime(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>-->
              <el-popconfirm title="确定要删除此设备绑定吗？" @onConfirm="deleteClassEquiment(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改设备绑定' : '添加设备绑定'"
      :visible.sync="showEdit"
      width="430px"
      @closed="resetForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="设备编码:" prop="uuid">
          <el-input v-model="editForm.uuid" placeholder="请输入设备编码"></el-input>
        </el-form-item>

        <el-form-item label="选择班级:" prop="classId">
          <treeselect
            v-model="editForm.classId"
            :options="classTree"
            :disable-branch-nodes="true"
            placeholder="请选择所属班级"
            :defaultExpandLevel="4"
            style="line-height: 20px"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
          />
        </el-form-item>
        <el-form-item label="设备类型:" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio :label="1">蓝牙</el-radio>
            <el-radio :label="2">扫码</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveClassEquiment(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { saveBeacon, delBeacon, getAllClassTree } from '@/config/api';
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';

  export default {
    name: '',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/beacon/page',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        data: null,
        choose: [],
        classTree: [], //班级树数据
        editForm: {
          uuid: null,
          classId: null,
          type: null,
        },
        editRules: {
          uuid: [{ required: true, message: '请设备编码', trigger: 'blur' }],
          classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
          type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        },
        showEdit: false,
      };
    },
    mounted() {
      this.queryClassTree();
    },
    methods: {
      /* 查询班级树 */
      queryClassTree() {
        getAllClassTree().then((res) => {
          if (res.data.resCode == 200) {
            this.classTree.push(res.data.data);
            this.deleteChildren(this.classTree);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].orgType !== 4) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
      // 打开添加设备绑定弹窗
      addClassEquiment() {
        this.showEdit = true;
      },
      // 编辑设备绑定
      // editClassTime(row) {
      //   this.editForm = Object.assign({}, row);
      //   this.showEdit = true;
      // },
      // 保存设备绑定
      saveClassEquiment() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            this.editForm.classId = this.editForm.classId.slice(1);
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveBeacon(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除设备绑定
      deleteClassEquiment(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        delBeacon(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 重置表单
      resetForm() {
        this.editForm = {
          uuid: null,
          classId: null,
          type: null,
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped lang="scss"></style>
